import { FC } from 'react';
import { PortableText, PortableTextBlock } from '@portabletext/react';

type RichTextProps = {
  text: PortableTextBlock[];
};

const RichText: FC<RichTextProps> = ({ text }) => {
  const innerText = text.map((_text) => ({
    ..._text,
    children: _text.children.map((child) => ({
      ...child,
      text: child.text.replace(/\s+/g, ' '),
    })),
  }));

  return <PortableText value={innerText} />;
};

export default RichText;
